import { useAtomValue } from 'jotai';

import { layoutAtom } from '@store';
import { Button, Modal, typography } from '@ui';

type SaveAsCopyConfirmationModallProps = {
    onDismiss: () => void;
    onSubmit: () => void;
};

export const SaveAsCopyConfirmationModal = ({ onDismiss, onSubmit }: SaveAsCopyConfirmationModallProps) => {
    const layout = useAtomValue(layoutAtom);
    return (
        <Modal
            variant="partial"
            title="Save layout as a copy"
            onDismiss={onDismiss}
            open
            footer={{
                primary: (
                    <Button variant="primary" onClick={onSubmit}>
                        Save
                    </Button>
                ),
                secondary: (
                    <Button variant="secondary" onClick={onDismiss}>
                        Cancel
                    </Button>
                ),
            }}
        >
            <p className={typography({ variant: 'p' })} style={{ maxWidth: 600 }}>
                Save layout as "{layout?.name} copy" and set it to active?
            </p>
        </Modal>
    );
};
